import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Operator, Product, ProductionFinishState, SearchInput } from '../../../../generated/generated-types';
import { WidgetProcessStepGroupListComponent } from '../../../production/components/widget-process-step-group-list/widget-process-step-group-list.component';

@Component({
  selector: 'app-formly-process-step-groups-of-product',
  templateUrl: './formly-process-step-groups-of-product.component.html',
  styleUrls: ['./formly-process-step-groups-of-product.component.css'],
  standalone: true,
  imports: [
    WidgetProcessStepGroupListComponent
  ]
})
export class FormlyProcessStepGroupsOfProductComponent extends FieldType implements OnInit {

  startFilter = null;

  // get productId() {
  //   return this.model?.id == this.model;
  // }

  productId: string = null;

  constructor() {
    super();
  }

  ngOnInit() {

    this.form.valueChanges.subscribe((x: Product) => {

      let model: Product = this.model;

      if (x && model && model.id && model.id != this.productId)
        this.productId = model.id;
      this.startFilter = this.getSearchFilter();
    });

  }

  getSearchFilter() {

    if (this.productId)
      return {
        searchFilter: {
          rules: [
            {
              field: "source.productId",
              operator: Operator.equal,
              value: this.productId
            }, {
              field: "finishState",
              operator: Operator.in,
              value: JSON.stringify([ProductionFinishState.UN, ProductionFinishState.IW])
            },
            {
              field: "isTemplate",
              operator: Operator.notequal,
              value: "true"
            },
          ]
        }
      } as SearchInput;
  }

}
